import Button from "@/components/base/Button";

export default function CallToAction() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-primary-500 rounded-lg px-6 py-12 md:py-16 md:px-16 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight max-w-3xl mx-auto">
            Chaque geste compte. Rejoignez Humanity59 dès aujourd'hui.
          </h2>
          <p className="mt-4 text-base md:text-lg text-background-50/90 max-w-2xl mx-auto">
            Rejoignez-nous, faites un don ou simplement partagez notre
            message. Ensemble, nous pouvons aller plus loin.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button to="/contact" variant="white" className="w-full sm:w-auto">
              Nous contacter
            </Button>
            <Button
              to="/don"
              variant="outline"
              className="w-full sm:w-auto"
            >
              <i className="ri-heart-3-line"></i>
              Faire un don
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}